import {
  Box,
  Space
} from '@looker/components'

import React, { useContext, useEffect } from 'react'
import { Email } from '@styled-icons/evaicons-solid'
import { Infinity } from '@styled-icons/bootstrap'

import _ from 'lodash'
import { useParams } from 'react-router'
import { Background } from '../Images/Background'

import { Vcard } from './../Vcard';

export const Card: React.FC<any> = ({
    dataRow,
    offerings
}) => {

  return (
    <>
    <Box className='card-container'>
      <div className='card-supplier-name-container'>
      <h4 className='card-supplier-name'><b>{dataRow['supplier_db.org_name']}</b></h4>
              <Vcard contactData={dataRow} buttonText="Add to Contacts" /></div>
      <div className='card-details'>
        <p>{dataRow['supplier_db.address_line_1']}</p>
        <p>{dataRow['supplier_db.city']}, {dataRow['supplier_db.state_or_province']} {dataRow['supplier_db.postal_code']}</p>
        <p> {dataRow['supplier_db.country_name']}</p>
      </div>
      <div className='divider' style={{paddingTop:'10px'}}></div>
      <div className='card-details'>
        <p>{dataRow['supplier_db.member_name']}</p>
        <p style={{display:'flex'}}>
          {dataRow['supplier_db.email']?
          <>
            <a href={`mailto: ${dataRow['supplier_db.email']}`}>
              <div className='card-icon'>
                <Email style={{fill:'black'}}/>
              </div>
            </a>
          </>
          :''
          }          
          {dataRow['impexium_orgs.website']?
          <>
            <a href={dataRow['impexium_orgs.website']}>
              <div className='card-icon'>
                <Infinity style={{fill:'black'}}/>
              </div>
            </a>
          </>
          :''
          }          
        </p>
      </div>
      <div className='tag-list'>
        {
          dataRow['supplier_db.market_scopes']?.split(", ").map(s => 
            <div className='tag market-scope' style={{backgroundColor:offerings[s]}}>{s}</div>
          )
        }
      </div>
      <div className='background-img'>
        <Background />
      </div>
    </Box>    
    </>
  )
}
